<template>
  <div>
    <el-row>
      <el-col span="16" :offset=4>
        <span style="font-size: 16px; font-weight: bold;">{{name}} 设定参数</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col span="16" :offset=4>
        <el-button @click="buttonClick('0')">
          全开
        </el-button>
        <el-button @click="buttonClick('1')">
          全关
        </el-button>
      </el-col>
      <el-col style="display: grid;padding: 0 80px;width: 100%">
        <div style="display: flex;align-items: center;height:50px;margin: auto;width: 100%">
          <p style="padding-right: 10px ">左前</p>
          <el-radio v-model="operateTypeBeforL" label="0" style="margin-right: 20px">开</el-radio>
          <el-radio v-model="operateTypeBeforL" label="1" style="margin-right: 20px">关</el-radio>
          <el-select v-model="stepLengthBeforL" size="small" class="selectStyle" placeholder="请选择" :style="operateTypeBeforL === '0' ? '': 'display: none'">
            <el-option
                v-for="optionsItem in options"
                :key="optionsItem.value"
                :label="optionsItem.label"
                :value="optionsItem.value">
            </el-option>
          </el-select>
        </div>
        <div style="display: flex;align-items: center;height:50px;margin: auto;width: 100%">
          <p style="padding-right: 10px ">左后</p>
          <el-radio v-model="operateTypeAfterL" label="0" style="margin-right: 20px">开</el-radio>
          <el-radio v-model="operateTypeAfterL" label="1" style="margin-right: 20px">关</el-radio>
          <el-select v-model="stepLengthAfterL" size="small" class="selectStyle" placeholder="请选择" :style="operateTypeAfterL === '0' ? '': 'display: none'">
            <el-option
                v-for="optionsItem in options"
                :key="optionsItem.value"
                :label="optionsItem.label"
                :value="optionsItem.value">
            </el-option>
          </el-select>
        </div>
        <div style="display: flex;align-items: center;height:50px;margin: auto;width: 100%">
          <p style="padding-right: 10px ">右前</p>
          <el-radio v-model="operateTypeBeforR" label="0" style="margin-right: 20px">开</el-radio>
          <el-radio v-model="operateTypeBeforR" label="1" style="margin-right: 20px">关</el-radio>
          <el-select v-model="stepLengthBeforR" size="small" class="selectStyle" placeholder="请选择" :style="operateTypeBeforR === '0' ? '': 'display: none'">
            <el-option
                v-for="optionsItem in options"
                :key="optionsItem.value"
                :label="optionsItem.label"
                :value="optionsItem.value">
            </el-option>
          </el-select>
        </div>
        <div style="display: flex;align-items: center;height:50px;margin: auto;width: 100%">
          <p style="padding-right: 10px ">右后</p>
          <el-radio v-model="operateTypeAfterR" label="0" style="margin-right: 20px">开</el-radio>
          <el-radio v-model="operateTypeAfterR" label="1" style="margin-right: 20px">关</el-radio>
          <el-select v-model="stepLengthAfterR" size="small" class="selectStyle" placeholder="请选择" :style="operateTypeAfterR === '0' ? '': 'display: none'">
            <el-option
                v-for="optionsItem in options"
                :key="optionsItem.value"
                :label="optionsItem.label"
                :value="optionsItem.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="readonly === 0">
      <el-col span="16" :offset=4>
        <el-button type="primary" class="attr-window-button" round @click="save()">
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      operateTypeBeforL: '1',
      operateTypeBeforR: '1',
      operateTypeAfterL: '1',
      operateTypeAfterR: '1',
      stepLengthBeforL: '1',
      stepLengthBeforR: '1',
      stepLengthAfterL: '1',
      stepLengthAfterR: '1',
      options: [
        {
          value: '1',
          label: '10'
        },
        {
          value: '2',
          label: '20'
        },
        {
          value: '3',
          label: '30'
        },
        {
          value: '4',
          label: '40'
        },
        {
          value: '5',
          label: '50'
        }, {
          value: '6',
          label: '60'
        },
        {
          value: '7',
          label: '70'
        },
        {
          value: '8',
          label: '80'
        },
        {
          value: '9',
          label: '90'
        },
        {
          value: '10',
          label: '100'
        }
      ],
      returnStr: {
        data: {
          operateTypeBeforL: 1,
          operateTypeBeforR: 1,
          operateTypeAfterL: 1,
          operateTypeAfterR: 1,
          stepLengthBeforL: 1,
          stepLengthBeforR: 1,
          stepLengthAfterL: 1,
          stepLengthAfterR: 1
        },
        nameText: ''
      }
    }
  },
  computed: {
    getProperty: function() {
      return this.value
    }
  },
  watch: {
    getProperty: {
      handler: function(newValue) {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.value) {
        if (!this.value.data) {
          this.operateTypeBeforL = String(this.value.operateTypeBeforL)
          this.operateTypeBeforR = String(this.value.operateTypeBeforR)
          this.operateTypeAfterL = String(this.value.operateTypeAfterL)
          this.operateTypeAfterR = String(this.value.operateTypeAfterR)
          this.stepLengthBeforL = String(this.value.stepLengthBeforL)
          this.stepLengthBeforR = String(this.value.stepLengthBeforR)
          this.stepLengthAfterL = String(this.value.stepLengthAfterL)
          this.stepLengthAfterR = String(this.value.stepLengthAfterR)
        }
        // if (this.value.operateTypeBeforL) {
        //   this.operateTypeBeforL = String(this.value.operateTypeBeforL)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.operateTypeBeforR = String(this.value.operateTypeBeforR)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.operateTypeAfterL = String(this.value.operateTypeAfterL)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.operateTypeAfterR = String(this.value.operateTypeAfterR)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.stepLengthBeforL = String(this.value.stepLengthBeforL)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.stepLengthBeforR = String(this.value.stepLengthBeforR)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.stepLengthAfterL = String(this.value.stepLengthAfterL)
        // }
        // if (this.value.operateTypeBeforL) {
        //   this.stepLengthAfterR = String(this.value.stepLengthAfterR)
        // }
      }
    },
    save() {
      this.returnStr.data.operateTypeBeforL = Number(this.operateTypeBeforL)
      this.returnStr.data.operateTypeBeforR = Number(this.operateTypeBeforR)
      this.returnStr.data.operateTypeAfterL = Number(this.operateTypeAfterL)
      this.returnStr.data.operateTypeAfterR = Number(this.operateTypeAfterR)
      this.returnStr.data.stepLengthBeforL = Number(this.stepLengthBeforL)
      this.returnStr.data.stepLengthBeforR = Number(this.stepLengthBeforR)
      this.returnStr.data.stepLengthAfterL = Number(this.stepLengthAfterL)
      this.returnStr.data.stepLengthAfterR = Number(this.stepLengthAfterR)
      if (this.operateTypeBeforL === '1' && this.operateTypeBeforR === '1' && this.operateTypeAfterL === '1' && this.operateTypeAfterR === '1') {
        this.returnStr.nameText = this.name + ' 关'
      }
      else {
        this.returnStr.nameText = this.name + ' 开'
      }
      console.log(JSON.stringify(this.returnStr))
      this.$emit('callBackJson', this.returnStr)
    },
    buttonClick(e) {
      // 0：全开， 1：全关
      this.operateTypeBeforL = e
      this.operateTypeBeforR = e
      this.operateTypeAfterL = e
      this.operateTypeAfterR = e
    }
  }
}
</script>

<style scoped>
.el-row {
  text-align: center;
}
.el-row:not(:first-child) {
  margin-top: 16px;
}
.el-row:last-child {
  margin-top: 20px;
}
/deep/ .el-radio{
  display: block;
  line-height: 30px;
  white-space: normal;
  margin-right: 0;
}
.attr-window-button {
  width: 96px;
  height: 40px;
  background-color: #4D78FF;
  border-color: rgb(77, 120, 255);
}
.attr-window-button:hover {
  background-color: #355cd8;
}
.selectStyle {
  padding-left: 10px;
  width: 90px;
}
/deep/ .el-input__inner {
  /* background-color: #131B25;
  color:white ; */
}
/* /deep/.el-checkbox {
  color: #FFFFFF;
}
/deep/.el-radio{
  color: #FFFFFF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
   width: 16px;
   height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #99B0C5;
} */
</style>
